if (!window.laced) {
  window.laced = {}
}

window.laced.addProductToMonday = function (
  elem,
  sku,
  boardId,
  groupId,
  requestorId,
  ownerId,
  apiKey
) {
  elem.disabled = true
  let date = new Date()
  let weekAhead = new Date(date.getTime() + 7 * 24 * 60 * 60 * 1000)

  let columnValues = {
    people: requestorId,
    person: ownerId,
    status_1: 'Medium',
    status: 'In Studio',
    timeline: {
      from: date.toISOString().split('T')[0],
      to: date.toISOString().split('T')[0]
    },
    channel: 'PDP',
    numbers: 5,
    date: weekAhead.toISOString().split('T')[0]
  }
  let query =
    'mutation { create_item (board_id: ' +
    boardId +
    ', item_name: "' +
    sku +
    '", group_id: ' +
    groupId +
    ', column_values: ' +
    JSON.stringify(JSON.stringify(columnValues)) +
    ') { id } }'

  fetch('https://api.monday.com/v2', {
    method: 'post',
    headers: {
      'Content-Type': 'application/json',
      Authorization: apiKey
    },
    body: JSON.stringify({
      query: query
    })
  })
    .then((res) => res.json())
    .then((res) =>
      res['data'] ? elem.parentElement.remove() : (elem.disabled = true)
    )
}
